<script setup>
import { computed, onMounted, onUnmounted, ref } from 'vue';
import { useStore } from 'vuex';

const props = defineProps({
  dashboardAppTitle: { type: String, required: true },
});

const store = useStore();
const frame = ref(null);
const dashboardApps = computed(
  () => store.getters['dashboardApps/getRecords'] || []
);
const currentUser = computed(() => store.getters.getCurrentUser || {});
const dashboardApp = computed(() =>
  dashboardApps.value.find(app => app.title === props.dashboardAppTitle)
);
const frameUrl = computed(() => {
  const content = dashboardApp.value?.content || [];
  const item = content.find(entry => entry.type === 'frame');
  return item?.url || '';
});
const currentAgent = computed(() => {
  const { id, name, email } = currentUser.value;
  return { id, name, email };
});

const sendContext = target => {
  if (!target || !frameUrl.value) return;
  const origin = new URL(frameUrl.value).origin;
  target.postMessage(
    JSON.stringify({
      event: 'appContext',
      data: { currentAgent: currentAgent.value },
    }),
    origin
  );
};

const handleMessage = event => {
  if (
    event.data !== 'chatwoot-dashboard-app:fetch-info' ||
    !frameUrl.value ||
    event.origin !== new URL(frameUrl.value).origin
  ) {
    return;
  }
  sendContext(event.source);
};

onMounted(() => {
  store.dispatch('dashboardApps/get');
  window.addEventListener('message', handleMessage);
});
onUnmounted(() => window.removeEventListener('message', handleMessage));
</script>

<template>
  <div class="flex h-full w-full flex-col bg-n-background">
    <div
      v-if="!frameUrl"
      class="m-auto max-w-md rounded-lg border border-n-weak bg-n-solid-2 p-6 text-center"
    >
      <h1 class="text-base font-medium text-n-slate-12">
        Integração ClinicFlow não configurada
      </h1>
      <p class="mt-2 text-sm text-n-slate-11">
        Peça ao administrador para configurar o aplicativo
        “{{ dashboardAppTitle }}”.
      </p>
    </div>
    <iframe
      v-else
      ref="frame"
      :src="frameUrl"
      class="h-full w-full border-0"
      :title="dashboardAppTitle"
      @load="sendContext(frame && frame.contentWindow)"
    />
  </div>
</template>
